import { Customer } from "../models/User";

export const BILLING_RETURN_INTENT_KEY = "wavegen.billingReturnIntent";

export interface BillingReturnIntent {
  workspaceId: string;
  pendingEntitlementFingerprint: string | null;
}

export function pendingEntitlementFingerprint(
  pending: Customer["pendingTeamEntitlement"],
): string | null {
  if (!pending) return null;
  return JSON.stringify({
    teamEnabled: pending.teamEnabled,
    maxMembers: pending.maxMembers,
    effectiveAt: pending.effectiveAt,
    planId: pending.planId,
    scheduleId: pending.scheduleId || null,
  });
}

export function storeBillingReturnIntent(
  workspaceId: string,
  pending: Customer["pendingTeamEntitlement"],
): void {
  const intent: BillingReturnIntent = {
    workspaceId,
    pendingEntitlementFingerprint: pendingEntitlementFingerprint(pending),
  };
  window.sessionStorage.setItem(
    BILLING_RETURN_INTENT_KEY,
    JSON.stringify(intent),
  );
}

export function readBillingReturnIntent(): BillingReturnIntent | null {
  try {
    const value = window.sessionStorage.getItem(BILLING_RETURN_INTENT_KEY);
    if (!value) return null;
    const parsed = JSON.parse(value) as Partial<BillingReturnIntent>;
    if (
      typeof parsed.workspaceId !== "string" ||
      (parsed.pendingEntitlementFingerprint !== null &&
        typeof parsed.pendingEntitlementFingerprint !== "string")
    ) {
      return null;
    }
    return parsed as BillingReturnIntent;
  } catch {
    return null;
  }
}
